import moment from 'moment-timezone';
import { GRAPH_DATETIME_FORMAT } from './timeConstants';

export const isToday = (date: Date): boolean => {
  return (
    moment().format('DD dddd') ===
    moment(date, GRAPH_DATETIME_FORMAT).format('DD dddd')
  );
};
